import { useState } from "react";

import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const Item = ({ icon, action, text, subItems = [] }) => {
  const theme = useTheme();

  const hasSubItems = subItems.length > 0;
  const [subItemsActive, setSubItemsActive] = useState(false);

  return (
    <>
      <S.ItemWrapper
        onClick={() => {
          if (action) action();
          if (subItems.length) setSubItemsActive(!subItemsActive);
        }}
      >
        <GetIcon name={icon} color={theme.colors.neutral.white} />
        <p>{text}</p>
        {hasSubItems && (
          <S.Arrow
            onClick={(e) => {
              e.stopPropagation();
              setSubItemsActive(!subItemsActive);
            }}
            $active={subItemsActive}
          >
            <svg
              width="18"
              height="10"
              viewBox="0 0 18 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.33127 0.663164L9.00002 8.15191L16.6688 0.659413C16.89 0.441913 17.2463 0.445663 17.4638 0.666913C17.5725 0.779413 17.625 0.921913 17.625 1.06441C17.625 1.21066 17.5688 1.35691 17.4563 1.46566L9.39377 9.34066C9.17627 9.55441 8.82752 9.55441 8.60627 9.34066L0.543768 1.46566C0.322518 1.24816 0.318768 0.891913 0.532518 0.670664C0.746268 0.449414 1.11002 0.445663 1.33127 0.663164Z"
                fill={theme.colors.neutral.white}
              />
            </svg>
          </S.Arrow>
        )}
      </S.ItemWrapper>
      {subItemsActive && (
        <S.SubItems>
          {subItems.map((subItem, index) => (
            <S.SubItem key={index} onClick={() => subItem.action(subItem.name)}>
              <p>{subItem.text}</p>
            </S.SubItem>
          ))}
        </S.SubItems>
      )}
    </>
  );
};

export default Item;
